import React from "react"
import ExperienceDatesInput from "./experience-dates-input"
import ExperienceTextInput from "./experience-text-input"
import { FormattedMessage, useIntl } from "react-intl"

const ExperienceInputCertificate = ({ type }) => {
  const { formatMessage } = useIntl()

  return (
    <>
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-certificate-form-title-placeholder', defaultMessage: "Ex: CompTIA Security+" })}
        label={<FormattedMessage
          id="resume-experience-form-name"
          defaultMessage="Name"
        />}
        dataKey="title"
        required={true}
      />
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-certificate-form-issuer-placeholder', defaultMessage: "Ex. Computing Technology Industry Association" })}
        label={<FormattedMessage
          id="resume-experience-form-issuing-organization"
          defaultMessage="Issuing Organization"
        />}
        dataKey="issuer"
        required={true}
      />
      <ExperienceDatesInput
        label={<FormattedMessage
          id="resume-experience-form-issue-date"
          defaultMessage="Issue Date"
        />}
        dataKey="timePeriod"
        isSingle={true}
      />
      <ExperienceTextInput
        placeholder={formatMessage({ id: 'resume-experience-certificate-form-description-placeholder', defaultMessage: "Ex. Trained to analyze attack vectors, install and configure network and cloud security technologies, and implement public key infrastructure." })}
        label={<FormattedMessage
          id="resume-experience-form-description"
          defaultMessage="Description"
        />}
        dataKey="description"
        inputType="textarea"
      />
    </>
  )
}

export default ExperienceInputCertificate
